import { appEntry } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-100">
      <div className="section-container">
        <div className="max-w-3xl mx-auto bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          <div className="flex flex-col md:flex-row items-center gap-6 p-6 md:p-8">
            <div className="flex-shrink-0 w-32 h-32 md:w-40 md:h-40 rounded-2xl bg-gradient-to-br from-primary-400 to-accent-500 flex items-center justify-center">
              <i className="ri-smartphone-line text-white text-5xl md:text-6xl"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-xl md:text-2xl font-bold text-foreground-900 mb-2">
                {appEntry.title}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 mb-4">
                {appEntry.subtitle}
              </p>
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-2 mb-4">
                {appEntry.features.map((f, i) => (
                  <span
                    key={i}
                    className="text-xs text-foreground-600 bg-background-100 px-3 py-1 rounded-full border border-background-200"
                  >
                    <i className="ri-check-line text-primary-500 mr-1"></i>
                    {f}
                  </span>
                ))}
              </div>
              <div className="flex items-center justify-center md:justify-start gap-3">
                {appEntry.badges.map((badge) => (
                  <span
                    key={badge}
                    className="inline-flex items-center gap-1.5 px-4 py-2 bg-foreground-900 text-white text-sm font-medium rounded-lg cursor-pointer hover:bg-foreground-800 transition-colors whitespace-nowrap"
                  >
                    <i className={`ri-${badge === 'iOS' ? 'apple' : 'android'}-line`}></i>
                    {badge} 版下载
                  </span>
                ))}
              </div>
            </div>
            <div className="flex-shrink-0 hidden md:block">
              <img
                src={appEntry.downloadQr}
                alt="91吃瓜APP下载二维码"
                className="w-28 h-28 rounded-xl border border-background-200"
                width="300"
                height="300"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}